module.exports = __webpack_public_path__ + "images/fa-city-shadows-mobile.jpg";